var SENTRY_RELEASE;SENTRY_RELEASE={name: "next-app", version: "6.2.4"};